/**
 * Usage
 */
export enum UsageNameToCodeEnum {
    livebox = '11',
    tv = '21',
    tvStick = '22',
    mobile = '31',
    homelive = '33',
    sim = '41',
    eMultiSim = '42',
    multiSimI = '43',
    multiSimIA = '44',
    airbox = '45',
    flybox = '46',
    smartWatch = '48',
    Landline = '51',
    LandlinePrincipal = '52',
    LandlineCorps = '53',
    voipSip = '54',
    voipH323 = '55',
    voipLandline = '56',
    cybersecure = '61',
}
